import { brandMeta, navLinks } from "@/mocks/content";

export default function Footer() {
  return (
    <footer className="border-t border-orange-100 bg-[#fff4e6]">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6">
        <div className="flex flex-col gap-8 md:flex-row md:justify-between">
          <div className="max-w-sm">
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
              <span className="grid h-9 w-9 place-items-center rounded-xl bg-gradient-to-br from-rose-500 to-orange-400 text-lg text-white">
                <i className="ri-chat-smile-3-line" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl text-stone-800">{brandMeta.name}</span>
            </a>
            <p className="mt-3 text-sm leading-relaxed text-stone-500">
              {brandMeta.slogan}。专注网络流行语与吃瓜文化的轻量科普，帮你快速理解 53吃瓜、五三吃瓜等热梗的含义与用法。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-2">
            <nav aria-label="页脚导航">
              <h4 className="text-sm font-bold text-stone-700">栏目</h4>
              <ul className="mt-3 space-y-2.5">
                {navLinks.slice(0, 4).map((l) => (
                  <li key={l.id}>
                    <a
                      href={`#${l.id}`}
                      className="text-sm text-stone-500 transition-colors hover:text-rose-600"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
            <nav aria-label="更多导航">
              <h4 className="text-sm font-bold text-stone-700">更多</h4>
              <ul className="mt-3 space-y-2.5">
                {navLinks.slice(4).map((l) => (
                  <li key={l.id}>
                    <a
                      href={`#${l.id}`}
                      className="text-sm text-stone-500 transition-colors hover:text-rose-600"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
                <li>
                  <a
                    href={`mailto:${brandMeta.email}`}
                    className="text-sm text-stone-500 transition-colors hover:text-rose-600"
                  >
                    联系我们
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-orange-200/70 pt-6 text-center sm:flex-row sm:text-left">
          <p className="text-xs text-stone-400">
            © {new Date().getFullYear()} {brandMeta.name} · 内容为网络流行语科普整理，欢迎理性补充与纠正。
          </p>
          <p className="text-xs text-stone-400">理性吃瓜 · 不信谣 · 不传谣</p>
        </div>
      </div>
    </footer>
  );
}